export const ADMIN = 'Account Admin'
export const LICENSE_BUYER = 'License Buyer'
export const MEMBER = 'Member'
export const TOKEN_BUYER = 'Token Buyer'
